import moment from 'moment'
import constants from '../../../../../../../resources/js/constants'

const RANGE_TYPE_MONTH = 'month'
const RANGE_TYPE_INTERVAL = 'interval'
// const TYPE_DAYS = 'days'
const TYPE_UPDATES = 'updates'

export default {
  namespaced: true,
  state: {
    rangeType: RANGE_TYPE_INTERVAL,
    rangeMonth: moment().startOf('month').format('YYYY-MM-DD'),
    rangeFrom: moment().subtract(1, 'months').format(constants.DATE_INPUT_FORMAT),
    rangeTo: moment().format(constants.DATE_INPUT_FORMAT),
    type: TYPE_UPDATES,
    sengine: constants.SENGINE_YANDEX
  },
  mutations: {
    setRangeMonth (state, month) {
      state.rangeMonth = moment(month).format('YYYY-MM-DD')
    },
    setRangeTypeMonth (state) {
      state.rangeType = RANGE_TYPE_MONTH
    },
    setRangeTypeInterval (state) {
      state.rangeType = RANGE_TYPE_INTERVAL
    },
    setRangeFrom (state, from) {
      state.rangeFrom = moment(from, constants.DATE_INPUT_FORMAT).isValid()
        ? moment(from, constants.DATE_INPUT_FORMAT).format(constants.DATE_INPUT_FORMAT)
        : from
    },
    setRangeTo (state, to) {
      state.rangeTo = moment(to, constants.DATE_INPUT_FORMAT).isValid()
        ? moment(to, constants.DATE_INPUT_FORMAT).format(constants.DATE_INPUT_FORMAT)
        : to
    },
    setType (state, type) {
      state.type = type
    },
    setSengine (state, sengine) {
      state.sengine = sengine
    }
  },
  actions: {
    changeRangeMonth ({ commit }, month) {
      commit('setRangeMonth', month)
      commit('setRangeTypeMonth', month)
      window.vue.$emit('projectPositionsDataQueryChange')
    },
    changeRangeFrom ({ state, commit, getters }, from) {
      commit('setRangeFrom', from)

      if (getters.isRangeTypeMonth && state.rangeTo) {
        commit('setRangeTypeInterval')
      }

      if (state.rangeFrom && state.rangeTo) {
        window.vue.$emit('projectPositionsDataQueryChange')
      }
    },
    changeRangeTo ({ state, commit, getters }, to) {
      commit('setRangeTo', to)

      if (getters.isRangeTypeMonth && state.rangeFrom) {
        commit('setRangeTypeInterval')
      }

      if (state.rangeFrom && state.rangeTo) {
        window.vue.$emit('projectPositionsDataQueryChange')
      }
    },
    changeType ({ state, commit, getters }, type) {
      commit('setType', type)

      window.vue.$emit('projectPositionsDataQueryChange')
    },
    changeSengine ({ commit }, sengine) {
      commit('setSengine', sengine)
      window.vue.$emit('projectPositionsDataQueryChange')
    }
  },
  getters: {
    isRangeTypeMonth: state => {
      return state.rangeType === RANGE_TYPE_MONTH
    },
    isRangeTypeInterval: state => {
      return state.rangeType === RANGE_TYPE_INTERVAL
    },
    fetchFrom: state => {
      return state.rangeType === RANGE_TYPE_MONTH
        ? moment(state.rangeMonth).startOf('month')
        : moment(state.rangeFrom, constants.DATE_INPUT_FORMAT)
    },
    fetchTo: state => {
      return state.rangeType === RANGE_TYPE_MONTH
        ? moment(state.rangeMonth).endOf('month')
        : moment(state.rangeTo, constants.DATE_INPUT_FORMAT)
    }
  }
}
